import { requests } from './baseServices'

export const CompanyServices = {    
    getAll: (criteria) => requests.get('api/companies', criteria),
    getAllWithOptions: (criteria) => requests.post('api/companies/filtered', criteria),
    getById: (id) => requests.get(`api/companies/${id}`),
    update: (id, template) => requests.put(`api/companies/${id}`, template),
    create: (template) => requests.post(`api/companies`, template),
    duplicate: (id) => requests.post(`api/companies/duplicate/${id}`),
    delete: (id) => requests.delete(`api/companies/${id}`),
    search: (query) => requests.get('api/companies/search', { query: query }),
};